<template>
  <v-card outlined class="pa-3">
    <div class="text-subtitle-2 mb-2">Datos para la factura</div>
    <v-alert type="info" text dense class="mb-3">
      Opcional. Solo se registrará si completa Razón social y NIT / CI.
    </v-alert>
    <v-checkbox
      v-model="registrarFactura"
      label="Registrar datos para factura"
      dense
      hide-details
      class="mt-0 mb-3"
    />
    <v-form ref="form" v-model="valid">
      <v-text-field
        v-model.trim="form.razon_social"
        :rules="facturaRules"
        :disabled="!registrarFactura"
        label="* Razón social:"
        dense
        outlined
        hide-details="auto"
        class="mb-3"
      />
      <v-text-field
        v-model.trim="form.nit_ci"
        :rules="facturaRules"
        :disabled="!registrarFactura"
        label="* NIT / CI:"
        dense
        outlined
        hide-details="auto"
        class="mb-3"
      />
      <v-textarea
        v-model.trim="form.observaciones"
        :disabled="!registrarFactura"
        label="Observaciones"
        dense
        outlined
        rows="2"
        auto-grow
        hide-details="auto"
      />
    </v-form>
  </v-card>
</template>

<script>
  import { createComprobanteDataFactura } from '../utils';

  export default {
    props: {
      inscripcionId: {
        type: [Number, String],
        required: true,
      },
      razonSocialDefault: {
        type: String,
        default: '',
      },
      nitCiDefault: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        valid: false,
        loading: false,
        registrarFactura: false,
        comprobanteDataFactura: null,
        facturaRules: [
          () => !this.registrarFactura || this.tieneDatosCompletos || 'Complete Razón social y NIT / CI para registrar factura',
        ],
        form: {
          razon_social: this.razonSocialDefault || '',
          nit_ci: this.nitCiDefault || '',
          observaciones: null,
        },
      };
    },
    computed: {
      tieneDatosParciales() {
        return !!(this.form.razon_social || this.form.nit_ci || this.form.observaciones);
      },
      tieneDatosCompletos() {
        return !!(this.form.razon_social && this.form.nit_ci);
      },
    },
    watch: {
      razonSocialDefault(value) {
        if (!this.form.razon_social) this.form.razon_social = value || '';
      },
      nitCiDefault(value) {
        if (!this.form.nit_ci) this.form.nit_ci = value || '';
      },
    },
    methods: {
      validar() {
        return this.$refs.form ? this.$refs.form.validate() : false;
      },
      async guardar() {
        if (!this.registrarFactura) return { omitido: true };
        if (!this.validar()) return null;

        const inscripcionId = Number(this.inscripcionId);
        if (!inscripcionId) {
          this.$root.$notify.show('No se encontró el ID de inscripción para datos de factura', { color: 'red', x: 'right' });
          return null;
        }

        this.loading = true;
        const res = await createComprobanteDataFactura({
          inscripcion_id: inscripcionId,
          razon_social: this.form.razon_social,
          nit_ci: this.form.nit_ci,
          observaciones: this.form.observaciones,
        }).catch((e) => e);
        this.loading = false;

        if (res && !res.error) {
          this.comprobanteDataFactura = res;
          return this.comprobanteDataFactura;
        }

        const message = res?.error || res?.message || 'No se pudo guardar los datos para factura';
        this.$root.$notify.show(message, { color: 'red', x: 'right' });
        return null;
      },
    },
  };
</script>
